export const FETCHING_WATCHED = "FETCHING_WATCHED";
export const FETCHED_WATCHED = "FETCHED_WATCHED";
export const RECEIVED_WATCHED = "RECEIVED_WATCHED";
export const CREATED_WATCHED = "CREATED_WATCHED";
export const DELETED_WATCHED = "DELETED_WATCHED";
